import { Box, Container, Heading } from '@chakra-ui/react';
import { FC, PropsWithChildren } from 'react';

export const Header: FC<PropsWithChildren> = ({ children }) => {
  return (
    <Box
      as="header"
      bgImage="radial-gradient(98.44% 95.14% at -0.8% 0%, #f563ff 0%, rgba(8, 255, 255, 0.5) 10.76%, rgba(15, 255, 231, 0.35) 30%, rgba(255, 120, 147, 0.1) 55%, rgba(0, 5, 15, 0) 86%)"
      bgColor="black"
      position="relative"
      bgSize="100%"
      mt="-104px"
      pt="104px"
      mb={{ base: 10, md: 20 }}
    >
      <Container css={{ position: 'relative' }}>
        <Heading
          as="h1"
          color="white"
          fontSize={{ base: '40px', lg: '5xl' }}
          lineHeight={{ base: '48px', lg: '140%' }}
          pt={{ base: '60px', lg: 20 }}
          pb={{ base: 14, lg: 10 }}
          px={0}
          textAlign="left"
        >
          {children}
        </Heading>
      </Container>
    </Box>
  );
};
